var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
var RouterLink = function (_a) {
    var children = _a.children, style = _a.style, tubeColor = _a.tubeColor, dispatch = _a.dispatch, other = __rest(_a, ["children", "style", "tubeColor", "dispatch"]);
    return (React.createElement(Link, __assign({}, other, { style: __assign({ color: tubeColor }, style) }), children));
};
var mapStateToProps = function (state) { return ({
    tubeColor: state.auth.tube.color,
}); };
export default connect(mapStateToProps, null)(RouterLink);



//////////////////
// WEBPACK FOOTER
// ./src/components/reusable/RouterLink.tsx
// module id = 417
// module chunks = 81